export default __webpack_public_path__ + "static/media/cantina-logo-v3.826b576b.png";